import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import DatePicker, { DateObject } from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import Select from "react-select";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const Appointment = ({ show, onClose, selectedId, refresh, name, mobile, email }) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [departmentopt, setdepartmentopt] = useState([]);
    const [department, setDepartment] = useState(null);
    useEffect(() => {
        axios.get(`${baseURL}/dropdown/get_department`)
            .then(response => {
                const formatted = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.department_name,
                }));
                setdepartmentopt(formatted);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
            });
    }, []);

    const [staffopt, setstaffopt] = useState([]);
    const [staff, setStaff] = useState(null);
    useEffect(() => {
        if(department) {
            axios.get(`${baseURL}/dropdown/get_staff/${department}`)
                .then(response => {
                    const formatted = response.data.data.map(item => ({
                        value: item.sno,
                        label: item.name,
                    }));
                    setstaffopt(formatted);
                })
                .catch(error => {
                    console.error('There was an error fetching the data!', error);
                });
        }
    }, [department]);
    
    const [appointmentdate, setDate] = useState(null);
    const handleDateChange = (dateValue) => {
        // Format the selected date to 'YYYY-MM-DD' and store it in the state
        if (dateValue) {
          const formattedDate = dateValue.format('YYYY-MM-DD');
          setDate(formattedDate);
        } else {
          setDate(null);
        }
    };

    const [appointmenttime, setTime] = useState(null);
    const handleTimeChange = (timeValue) => {
        if (timeValue) {
            // Format the selected time to 'H:i' (24-hour format)
            const formattedTime = timeValue.format('HH:mm');
            setTime(formattedTime);
        } else {
            setTime(null); // If no time is selected, set time as null
        }
    };

    const [app_catego, setappcatego] = useState(null);
    const [app_reason, setappreason] = useState(null);
    const [description, setDescription] = useState(null);

    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};

        if (!app_catego) {
            newErrors.catego = "This Field is Required.";
        }

        if (!appointmentdate) {
            newErrors.date = "This Field is Required.";
        }
        
        if (!appointmenttime) {
            newErrors.time = "This Field is Required.";
        }

        if (!app_reason) {
            newErrors.res = "This Field is Required.";
        }

        if (!staff) {
            newErrors.staff = "This Field is Required.";
        }

        if (!department) {
            newErrors.dept = "This Field is Required.";
        }

        return newErrors;
    };
    
    const user_id = parseInt(localStorage.getItem("user_id"), 10);

    const handleSubmit = (event) => {
        event.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const postData = { 
            lead: selectedId,
            appointment_category: app_catego,
            assigned_department: department,
            assigned_staff: staff,
            appointment_date: appointmentdate,
            appointment_time: appointmenttime,
            appointment_reason: app_reason,
            description: description,
            created_by: user_id,
         };
        axios.post(`${baseURL}/appointment`, postData)
            .then(response => {
                onClose();
                refresh();
                toast.success("Appointment Created Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Appointment Creation Failed");
            });
    };

    const appointment_category = [
        { value: 1, label: "Walk-in" },
        { value: 2, label: "Online" },
        { value: 3, label: "Ofline" },
        { value: 4, label: "Video" },
        { value: 5, label: "Payment" }
    ];

    return (
        <Modal show={show} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Appointment Schedule</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className='col-lg-12 mb-3'>
                                <div className="row">
                                    <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                                        <label className='text-gray-800 font-w500 fs-7'>Lead</label>
                                        <label className='text-black fs-6 font-w500'>{name}</label>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                                        <label className='text-gray-800 font-w500 fs-7'>Mobile No</label>
                                        <label className='text-black fs-6 font-w500'>{mobile}</label>
                                    </div>
                                    {/* <div className='col-lg-12 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                                        <label className='text-gray-800 font-w500 fs-7'>Email ID</label>
                                        <label className='text-black fs-6 font-w500'>{email ? email : '-'}</label>
                                    </div> */}
                                </div>
                            </div>
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Appointment Category<span className="required">*</span></label>
                                <Select
                                    placeholder="Select Category"
                                    options={appointment_category}
                                    onChange={(e) => setappcatego(e.value)}
                                />
                                {errors.catego && <div className="text-danger fs-8 mt-1">{errors.catego}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Appointment Date<span className="required">*</span></label>
                                <div className='datepicker-wrapper d-flex'>
                                    <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                    <DatePicker placeholder='Select Date'
                                        onChange={handleDateChange}
                                        format="DD-MM-YYYY"
                                        // maxDate={new Date(new Date().setHours(23, 59, 59, 999))}
                                    />
                                </div>
                                {errors.date && <div className="text-danger fs-8 mt-1">{errors.date}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Appointment Time<span className="required">*</span></label>
                                <div className='datepicker-wrapper d-flex'>
                                    <div className='input-group-text bg-transparent border-0 px-0'>
                                        <i className='fa-solid fa-clock fs-4'></i>
                                    </div>
                                    <DatePicker placeholder='Select Time'
                                        disableDayPicker
                                        onChange={handleTimeChange}
                                        format="hh : mm A"
                                        showTime={{
                                            format: "hh:mm A", // 12-hour format for display
                                            use12Hours: true, // 12-hour clock
                                        }}
                                        plugins={[
                                            <TimePicker />
                                        ]}
                                    />
                                </div>
                                {errors.time && <div className="text-danger fs-8 mt-1">{errors.time}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Department<span className="required">*</span></label>
                                <Select
                                    placeholder="Select Department"
                                    options={departmentopt}
                                    onChange={(e) => setDepartment(e.value)}
                                />
                                {errors.dept && <div className="text-danger fs-8 mt-1">{errors.dept}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Assigned  Staff<span className="required">*</span></label>
                                <Select
                                    placeholder="Select Staff"
                                    options={staffopt}
                                    onChange={(e) => setStaff(e.value)}
                                />
                                {errors.staff && <div className="text-danger fs-8 mt-1">{errors.staff}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Appointment Reason<span className="required">*</span></label>
                                <input type="text" className="form-control" placeholder="Enter Reason"
                                    maxLength={100}
                                    value={app_reason} 
                                    onChange={(e) => setappreason(e.target.value)} 
                                />
                                {errors.res && <div className="text-danger fs-8 mt-1">{errors.res}</div>}
                            </div>
                            <div className="col-lg-12 mb-3">
                                <label className="text-black font-w500 fs-7">Description</label>
                                <textarea rows={8} className="form-control" name="comment" placeholder="Enter Description" 
                                    maxLength={200}
                                    value={description} 
                                    onChange={(e) => setDescription(e.target.value)} 
                                />
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                            <button type="submit" className="btn btn-sm btn-primary">Appointment Schedule <i className="fas fa-angle-double-right ms-2"></i></button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
};

export default Appointment;
